import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "React for Dataviz Turkey 🦃 sale report for the curious",
  "description": "",
  "published": "2018-11-28T00:00:00.000Z",
  "redirect_from": ["/blog/react-dataviz-turkey-sale-report-curious/swizec/8788"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Launching `}<a parentName="p" {...{
        "href": "https://swizec1.teachable.com/p/react-for-data-visualization/"
      }}>{`React for Data Visualization`}</a>{` on turkey day was a last minute decision. So last minute, in fact, that I renamed the course Sunday evening. 2 days before the first email went out.`}</p>
    <p>{`See, I've been working on this since early August.`}</p>
    <p>{`Well, the first version of my React data visualization stuff went `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-a-book-i-wrote-in-two-weeks-made-4000-in-its-first-month/swizec/6675"
      }}>{`on sale in April 2015`}</a>{`. Made $4,000 in its first month, too. 💪`}</p>
    <p>{`Fast forward to late 2018.`}</p>
    <p>{`Book has seen 3 or 4 major rewrites. Kept up with React and D3. It's been a great project, but sales are stagnating. A little tired of the topic. Looking for the next thing and not quite finding one.`}</p>
    <p>{`Knowing I should update the book but ugh who cares…`}</p>
    <p>{`Then the Director of Data Visualization at Visa emails me in July. I didn't know such a thing as a director of data visualization existed, but he emailed me and said: `}<em parentName="p">{`"Dude, we love your React + D3v4 book. But come on. Can't you update? It's out of date."`}</em></p>
    <p>{`When the director of data visualization at Visa emails you, that's a strong signal. The market still cares. Real people with real needs. And money to spend.`}</p>
    <h2 {...{
      "id": "time-for-an-update"
    }}>{`Time for an update!`}</h2>
    <p>{`A flurry of activity. August was intense.`}</p>
    <p>{`I put up a preorder on Gumroad. Working title `}<em parentName="p">{`"React + D3 2018"`}</em>{`. Asked my intern to build a landing page. Never used it. Wrote some quick copy for the Gumroad product description, set the price at $49, and emailed my list.`}</p>
    <p>{`A few sales.`}</p>
    <p>{`Okay, great. There's interest.`}</p>
    <p>{`This time, I wanted the book to have a real course. Not just some crappy little videos. A proper course that follows the book and teaches you everything.`}</p>
    <p>{`I suck at recording courses.`}</p>
    <p>{`Workshops! I'm good at holding workshops. We're gonna have 3 live workshops. A bonus for everyone who preorders.`}</p>
    <p>{`Bonus for me: Announcing each Sunday workshop is a great excuse to email my list.`}</p>
    <p><em parentName="p">{`And I can ask people what they learned, what excites them, and why they're interested.`}</em>{` Copywriting and sales gold right there.`}</p>
    <p>{`Put up some ads. Got a cover design on 99designs. Kept emailing my list.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/gumroad-screen-1-1024x505.png",
        "alt": null
      }}></img></p>
    <p>{`By the end of August, I had 104 preorders. A quarter updated book. Updated code samples. And a final cover design chosen via popular vote and Facebook ads.`}</p>
    <h2 {...{
      "id": "the-hard-work-begins"
    }}>{`The hard work begins`}</h2>
    <p>{`Preorders in hand and charged, a sinking feeling.`}</p>
    <p>{`There's no way I can finish this by the start of September. Not with a day job. Not when I'm spending every morning on mastermind and client calls.`}</p>
    <p>{`So I emailed everyone.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hey this is gonna take some time. Updating a 250-page book after JavaScript has been evolving for a year… it's a lot of work. Editing those 4 hours of workshop video? Oof`}</p>
    </blockquote>
    <p>{`Rolled up my sleeves and got to work. Every day, I would write a little. Code a little. Nudge things along.`}</p>
    <p>{`Every few weeks, I'd send out an update. `}<em parentName="p">{`"Hey, here's a new PDF. Hope you like. Still working on it. Thanks for your patience."`}</em></p>
    <p>{`They understood. Everyone was great about it.`}</p>
    <p>{`People kept buying the old book. My automations are left un-updated. My landing page is still for the old version. When you sign up for my mailing list, it still pitches you the old version of the book.`}</p>
    <p>{`Ugh.`}</p>
    <p>{`No matter! We'll give people who ask a free upgrade to the new stuff. Everyone's happy with this arrangement. Every now and then, I sweep the list, find everyone with a recent purchase, and offer them a coupon.`}</p>
    <p>{`A few more React + D3 2018 buyers trickle in.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/gumroad-screen-2-1024x487.png",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "react-for-data-visualization-is-born"
    }}>{`React for Data Visualization is born`}</h2>
    <p>{`At some point while updating the book, I realize this just isn't going to work.`}</p>
    <p>{`Too many quips about how silly it is that in 2018 I still can't embed gifs in electronic books. Too many problems with emoji support for Markdown → PDF/epub/mobi generators. Too hard to make code nicely copy-pastable.`}</p>
    <p>{`The UX is shit. I'm asking people to pay real money for this? We can do better!`}</p>
    <p>{`React + D3 2018 was to become a full course. Hosted online. Embedded code editors, videos for everything. Make it real easy for people to learn.`}</p>
    <p>{`Because let's be honest, most people learning to code do so at a computer with a nice big monitor. They copy-paste code. They have a browser.`}</p>
    <p>{`Why not put the book in the browser and make it easy for them?`}</p>
    <p>{`Although I did see a lady watching coding videos on the elliptical the other day. That was cool. Not something she could do with an ebook.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Wow gal next to me is watching coding videos on the elliptical. So SF`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1067254859143905281"
      }}>{`November 27, 2018`}</a></blockquote>
    <p>{`Hell, if you make your book an online course, you can neatly pair videos with each section.`}</p>
    <p>{`Solves a major problem with video courses: They're boring, and videos drag on forever. You wanna jump around. You wanna skip to the good parts. You wanna focus on what you're trying to learn, not the author's long-winded introduction.`}</p>
    <p>{`With a video per section, subchapter even, I can ensure no single video is longer than 5 minutes. Keep them focused and on topic. Make it easy to jump around.`}</p>
    <lite-youtube {...{
      "videoid": "7HQzbq4s7MQ",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`But editing 8 hours of video was kicking my ass. September came and went. October was behind us. End of November closing in fast.`}</p>
    <p>{`Yes, 8 hours of video. Up from the earlier 4 hours. Had to record a workshop thing of building the main example in the course. That's how you can have video with everything 🧐`}</p>
    <h2 {...{
      "id": "a-haphazard-launch"
    }}>{`A haphazard launch`}</h2>
    <p>{`So, moment of truth. Course not done. Markdown messing with us. Video editing kicking my ass. Launch window closing fast. 6 more weeks left in the year.`}</p>
    <p>{`Gotta do something.`}</p>
    <p>{`Will people pay money for this? Is it worth pressing on? Have I burnt out my audience? Does anyone still care? Can I afford to pay everyone who's been helping me make it happen?`}</p>
    <p>{`Shawn built a landing page. Then another. Then tweaked it. Then made it better. I still wasn't ready with the copy so we could launch. Ugh.`}</p>
    <p>{`Helder basically reinvented markdown pandoc something something. Trying to get emojis to work. No good. Then he invented a script and a hack that let us import markdown into Teachable. Awesome work, makes the whole thing viable.`}</p>
    <p>{`And we can update the course with a git push 🤘`}</p>
    <p>{`I been updating content and editing videos for months.`}</p>
    <p>{`Was all the effort worth it? Am I throwing money down the drain paying people to help me make it happen?`}</p>
    <p>{`Thanksgiving, Black Friday, and Cyber Monday are upon us. Now's the time to find out!`}</p>
    <p>{`Sunday night, I came up with a plan: Run a promotion for this unfinished course over turkey weekend 🦃. Set the price at a steep discount from the future full price.`}</p>
    <p>{`$97 instead of $149.`}</p>
    <p>{`Everyone can get the written parts immediately. And I promise to pump out the rest of video stuff as fast as I can. Additional chapters on WebGL, VR, React Native, and server-side-rendering coming by end of year.`}</p>
    <p>{`To promote the sale, I would send an email to my entire list every day for the entire duration of the sale. Each email will have a little timer gif.`}</p>
    <h2 {...{
      "id": "the-experiment"
    }}>{`The experiment`}</h2>
    <p>{`The turkey launch experiment was geared to answer a few questions:`}</p>
    <ol>
      <li parentName="ol">{`Will people pay a solid price for this material?`}</li>
      <li parentName="ol">{`Will people hate me if I email every day?`}</li>
      <li parentName="ol">{`Can I generate some cash flow?`}</li>
      <li parentName="ol">{`Does this text with short videos format resonate with people?`}</li>
    </ol>
    <p>{`Monday night, I renamed the course to React for Data Visualization. Much better title. Tuesday morning, I sent the first email:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hey I'm launching this course. Short videos and text and code. I don't have a landing page yet, you can buy it tomorrow. Reply if you care.`}</p>
    </blockquote>
    <p>{`A few replies came in. That evening, we got Teachable markdown import to work. I hacked the cover from 99designs to fit the new title.`}</p>
    <p>{`For the next few days, I kept emailing. Every morning, the first thing I did was write an email to my audience. Look at this wonderful thing. A beautiful promotion. You can learn and hack and have some fun and it's cheaper than it's ever gonna be.`}</p>
    <p>{`I played with words. I played with angles. I explained it this way and that. I made an intro video. I sent emails long and short.`}</p>
    <p>{`On Monday, I hosted a live Q&A with a little example coding. That went well. Should've done it sooner.`}</p>
    <p>{`Then on Tuesday morning, I said `}<em parentName="p">{`"Last chance. Now or never."`}</em>{`. Set the coupon to expire at 12:00 and went to work.`}</p>
    <h2 {...{
      "id": "the-result"
    }}>{`The result`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2018/11/teachable-screen-1024x940.png",
        "alt": null
      }}></img></p>
    <p>{`7 emails 87 net subscribers lost 167 total unsubscribes 65 course sales $6500 in revenue before Teachable fees`}</p>
    <p>{`It's not the 100 I was hoping for, but it's cash in the bank, and I know people will pay a solid price for solid knowledge.`}</p>
    <p>{`Time to roll up my sleeves and finish those videos.`}</p>
    <p>{`💪`}</p>
    <p>{`Thank you everyone who purchased React for Data Visualization. You're the best.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      